export default function normalizeInitials(initials) {
  return initials.slice(0, 2);
}